<template>
  <div class="step-3-page">
    <div class="over-btn">
      <div class="header-block">
        <div class="insert-subject">
          {{ $t('heatmap.registration.subject') }}
        </div>

        <div class="tracking-code">
           <span>
          {{ $t('heatmap.registration.trackingCode') }}
          </span>
          <button class="code-check" @click="$emit('codeCheck', url)">
            <i class="icon icon--arrow-right-blue-xsmall"></i>
            <span>{{ $t('heatmap.registration.codeCheck') }}</span>
          </button>
        </div>

        <div class="url" ref="urlBox">
          {{ listUrl }}
        </div>
      </div>
      <div class="preview-description">
        <div class="text-block">
          <div class="preview-subject">
            {{ $t('heatmap.registration.preview.subject') }}
          </div>
          <div class="preview-desc">
            {{ $t('heatmap.registration.preview.content') }}
          </div>
        </div>
        <ui-button :iconName="'icon--retake white'" class="btn-confirm" :buttonType="'submit'" :primary="true" @click="capturePreview">
          {{ $t('heatmap.registration.screenshot') }}
        </ui-button>
      </div>
      <div class="content__body">
        <div class="heatmap__device">
          <button v-for="item in deviceItems"
                  type="button"
                  class="item"
                  :key="item"
                  :class="{on: item === selectedDevice}"
                  @click="setDevice(item)">
            <span class="text">{{ item }}</span>
          </button>
        </div>
        <div class="capture-before">
          <p v-if="canCapturePreview && !capturing"  v-html="$t('heatmap.registration.previewCapture.before')"></p>
          <div v-else-if="capturing && !captureResultSet[selectedDevice]" class="loading-header">
            <i class="icon icon--camera-size70-new"></i>
            <p class="title-loading" v-html="$t('heatmap.registration.previewCapture.loading')"></p>
            <div class="loading--wrap">
              <i class='loading-bar'></i>
              <i class='loading-bar'></i>
              <i class='loading-bar'></i>
              <i class='loading-bar'></i>
              <i class='loading-bar'></i>
            </div>
          </div>
          <div v-else class="disabled">
            <p class="title">
              <i class="icon icon--warning-red-size20"></i>
              <span>{{ $t('common.notice') }}</span>
            </p>
            <p class="desc" v-html="$t('page.registration.preview.screenShot.disabled')"></p>
          </div>
        </div>
        <div class="capture-after" ref="contentBody">
          <div v-for="deviceName in Object.keys(captureResultSet)"
              :key="deviceName"
              class="capture-container"
              :class="[{ on: selectedDevice === deviceName}, deviceName.toLowerCase() ]"
              :style="captureResultSet[deviceName].containerStyle">
            <div class="capture-failure" v-if="captureResultSet[deviceName].hasError">
              <p class="title">
                <i class="icon icon--camera-red-size70"></i>
                <br/>
                <span>{{ $t('heatmap.registration.previewCapture.fail.title') }}</span>
              </p>
              <p class="desc first" v-html="$t('heatmap.registration.previewCapture.fail.desc')"></p>
              <p class="desc" v-html="$t('heatmap.registration.previewCapture.fail.desc2')"></p>
              <p class="desc" v-html="$t('heatmap.registration.previewCapture.fail.desc3')"></p>
            </div>
            <template v-else>
              <div class="mask"></div>
              <div class="coords_rect"
                  v-for="(item, index) in captureResultSet[deviceName].coords"
                  :key="index"
                  :class="{ tracking_tag: item.isTrackingTag }"
                  :style="{ width: item.width, height: item.height, left: item.left, top: item.top }"></div>
            </template>
          </div>
        </div>
      </div>
    </div>
    <div class="btn-wrap">
      <div class="back-btn-wrap">
        <ui-button :iconName="'icon--arrow-left-black'" :style="{'margin-left': '245px'}" @click="backStep">
          {{ $t('common.prev') }}
        </ui-button>
      </div>
      <div class="reg-btn-wrap">
        <ui-button :iconName="'icon--check-white'" class="btn-confirm" :buttonType="'submit'" :primary="true" @click="register">
          {{ isEditMode ? $t('heatmap.registration.edit') : $t('common.register') }}
        </ui-button>
      </div>
    </div>
  </div>
</template>

<script>
import UiButton from '@/components/ui/UiButton'
import { requestPreviewCapture, getPreviewCaptureStatus } from '@/api/capture'
import httpClient from '@/libs/http-client'

const CAPTURE_STATE = {
  none: 0,
  failed: -1,
  waiting: 1,
  processing: 2,
  done: 3
}
const CAPTURE_SUCCESS = 10
function getS3Path (path) {
  const parts = path.split(':')
  return `https://s3.ap-northeast-2.amazonaws.com/${parts[0]}/${parts[1]}`
}

export default {
  name: 'HeatmapRegistrationStep3',
  components: {
    UiButton
  },
  data () {
    return {
      selectedDevice: 'Desktop',
      captureResultSet: {},
      captureResult: null,
      canCapturePreview: true,
      capturing: false
    }
  },
  props: {
    url: {
      default: ''
    },
    listUrl: {
      default: ''
    },
    jamCount: {
      default: 0
    },
    isEditMode: {
      default: false
    },
    model: {
      default: {}
    }
  },
  created () {
  },
  watch: {
    'captureResult.tasks' (items) {
      if (items) {
        this.checkCaptureResult(items, true)
      } else {
        this.setDevice(null)
        this.captureResultSet = {}
      }
    }
  },
  mounted () {
    if (this.captureResult && this.captureResult.tasks) {
      this.checkCaptureResult(this.captureResult.tasks)
    }
  },
  computed: {
    deviceItems () {
      if (this.bMobile) {
        return ['Phone']
      } else {
        return ['Desktop', 'Tablet', 'Phone']
      }
    }
  },
  methods: {
    setDevice (value) {
      this.selectedDevice = value
    },
    register () {
      this.$emit('register', this.model)
    },
    backStep () {
      this.$emit('backStep')
    },
    capturePreview () {
      this.startPreviewCapture()
    },
    loadCaptureImage (path, deviceName) {
      const url = getS3Path(path)

      return new Promise((resolve, reject) => {
        const img = document.createElement('img')
        img.addEventListener('load', event => {
          const el = event.target
          const containerWidth = this.$refs.contentBody.getBoundingClientRect().width
          const ratio = el.width / el.height
          let scale = containerWidth / el.width
          // let width = el.width
          let height = el.height

          if (scale < 1) {
            // width = width * scale
            height = height * scale
          } else {
            scale = 1
          }

          this.captureResultSet[deviceName] = {
            imageUrl: url,
            captureWidth: el.width,
            captureHeight: el.height,
            captureRatio: ratio,
            captureScale: scale,
            containerStyle: {
              // width: width + 'px',
              height: height + 'px',
              background: `url(${url}) no-repeat`,
              backgroundSize: '100%'
            },
            coords: null
          }
          resolve()
        })
        img.src = url
      })
    },
    loadCoords (path, deviceName) {
      const url = getS3Path(path)
      return httpClient.get(url).then(response => {
        const resultSet = this.captureResultSet[deviceName]
        const captureWidth = resultSet.captureWidth
        const captureHeight = resultSet.captureHeight
        const scale = resultSet.captureScale
        resultSet.coords = response.data.map(item => {
          let width = item[4]
          let height = item[5]
          let left = item[3]
          let top = item[0]

          const isValidRect = width > 0 && height > 0 &&
            top >= 0 && left >= 0 &&
            (left + width) <= captureWidth &&
            (top + height) <= captureHeight

          if (!isValidRect) {
            return null
          }

          return {
            width: (width * scale) + 'px',
            height: (height * scale) + 'px',
            left: (left * scale) + 'px',
            top: (top * scale) + 'px',
            isTrackingTag: !!item[7]
          }
        }).filter(item => !!item)
      })
    },
    checkCaptureResult (tasks, updateDeviceName) {
      for (const item of tasks) {
        const deviceName = item.deviceName
        const statusCode = item.statusCode
        const isSuccess = statusCode === CAPTURE_SUCCESS
        const isFailed = statusCode < 0

        if (!this.captureResultSet[deviceName] && (isSuccess || isFailed)) {
          this.$set(this.captureResultSet, deviceName, {}) // prevent duplicated loadCaptureImage

          if (isFailed) {
            this.$set(this.captureResultSet[deviceName], 'hasError', true)
            if (updateDeviceName) {
              this.setDevice(deviceName)
            }
          } else {
            this.loadCaptureImage(item.imagePath, deviceName).then(() => {
              return this.loadCoords(item.jsonPath, deviceName)
            }).then(() => {
              if (updateDeviceName) {
                this.setDevice(deviceName)
              }
            })
          }
        }
      }
    },
    getCapturePreview (id, uuid) {
      return new Promise((resolve, reject) => {
        this.captureResult = null
        window.clearInterval(this.previewTimer)

        const intervalFn = () => {
          getPreviewCaptureStatus(id, uuid).then(data => {
            this.captureResult = data

            if (this.captureResult.waitCount === 0) {
              this.captureState = CAPTURE_STATE.processing
            }
            const taskSize = data.tasks.length
            const doneTasks = data.tasks.filter(item => {
              return item.statusCode === CAPTURE_SUCCESS || item.statusCode < 0
            })
            if (taskSize === doneTasks.length) {
              resolve()
            }
          }).catch(err => {
            this.cancelPreviewCapture()
            reject(err)
          })
        }

        this.previewTimer = window.setInterval(intervalFn, 5000)
        intervalFn()
      })
    },
    cancelPreviewCapture () {
      window.clearInterval(this.previewTimer)
      this.resetCapturePreview()
      this.showRenderingLayer = false
    },
    startPreviewCapture (isRetake) {
      this.capturing = true
      if (!this.canCapturePreview) {
        return
      }
      this.capturing = true
      this.showPreviewLayer = false

      if (this.isRetake) {
        this.captureResult = null
      }
      this.showRenderingLayer = true
      this.captureState = CAPTURE_STATE.waiting
      const url = this.model.captureURL || this.model.url
      requestPreviewCapture({
        url,
        isMobile: !!this.model.bMobile,
        exceptionSelector: this.model.exceptionSelector ? this.model.exceptionSelector : ''
      }).then(data => {
        return this.getCapturePreview(data.requestId, data.uuid)
      }).then(result => {
        window.clearInterval(this.previewTimer)
        window.setTimeout(() => {
          const tasks = this.captureResult.tasks
          if (tasks) {
            const successTasks = tasks.filter(item => {
              return item.statusCode === CAPTURE_SUCCESS
            })

            if (successTasks.length === tasks.length) {
              this.selectedDevice = tasks[0].deviceName
              this.captureState = CAPTURE_STATE.done
              this.showRenderingLayer = false
            } else {
              this.captureState = CAPTURE_STATE.failed
            }
          }
        }, 500)
      }).catch(err => {
        this.cancelPreviewCapture()
        console.error(err)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.step-3-page {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .over-btn {
    height: 100%;
    width: 100%;
    padding-bottom: 25px;
    padding-right: 27px;
    overflow-y: auto;
    --scrollbar-width: 8px;
    --mask-height: 20px;
    --mask-image-content: linear-gradient(
        to bottom,
        black var(--mask-height),
        black calc(100% - var(--mask-height)),
        transparent
    );

    --mask-size-content: calc(100% - var(--scrollbar-width)) 100%;
    --mask-image-scrollbar: linear-gradient(black, black);
    --mask-size-scrollbar: var(--scrollbar-width) 100%;
    mask-image: var(--mask-image-content), var(--mask-image-scrollbar);
    mask-size: var(--mask-size-content), var(--mask-size-scrollbar);
    mask-position: 0 0, 100% 0;
    mask-repeat: no-repeat, no-repeat;
    .header-block {
      text-align: left;
      border-bottom: dashed 1px #c1c1c1;
      border-color: #c1c1c1;
      .insert-subject {
        color: #2F2F2F;
        margin-bottom: 5px;
        font-size: 15px;
        font-style: normal;
        font-weight: 500;
        line-height: 15px; /* 100% */
      }
      .tracking-code {
        & span {
          color: #767676;
          font-size: 12px;
          font-style: normal;
          font-weight: 400;
          line-height: 22px;
          display: inline-block;
          margin-bottom: 23px;
        }

        .code-check {
          position: relative;
          margin-left: 8px;

          & .icon {
            position: absolute;
            top: 50%;
            transform: translate(0, -50%);
          }

          & span {
            position: relative;
            color: #0074FF;
            font-size: 12px;
            font-style: normal;
            font-weight: 400;
            line-height: 18px;
            margin: 0 0 0 15px;
          }
        }
      }
      .url {
        color: #767676;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px; /* 183.333% */
        margin-bottom: 10px;
        word-break: break-all;
      }
    }
    .preview-description {
      display: flex;
      justify-content: space-between;
      margin-top: 20px;
      .text-block {
        text-align: left;
        .preview-subject {
          color: #2F2F2F;
          font-size: 13px;
          font-style: normal;
          font-weight: 500;
          line-height: 15px; /* 115.385% */
        }
        .preview-desc {
          color: #767676;
          font-size: 12px;
          font-style: normal;
          font-weight: 400;
          line-height: 22px; /* 183.333% */
        }
      }
    }
    .content__body {
      margin-top: 20px;
      background-color: #1b1b1d;
      height: calc(100% - 176px);
      position: relative;

      .heatmap__device {
        position: relative;
        z-index: 10;
        height: 36px;
        line-height: 34px;
        background-color: #0c0c0c;
        padding-left: 31px;
        text-align: left;
        button {
          height: 36px;
          margin-right: 43px;
          font-size: 14px;
          font-weight: bold;
          color: #888888;
          position: relative;
          &:hover {
            color: #fff;
          }
          &.on {
            color: $brandColor;
          }
        }
      }

      .capture-before {
        @include positionXYcenter;
        width: 100%;
        padding: 20px;
        box-sizing: border-box;
        p {
          font-size: 13px;
          font-weight: bold;
          line-height: 1.54;
          text-align: center;
        }
        .title-loading {
          color: #FFF;
          font-size: 20px;
          font-style: normal;
          font-weight: 500;
          line-height: 20px; /* 100% */
        }
        .loading--wrap {
          width: 180px;
          height: 12px;
          margin: 20px auto 17px;
          .loading-bar {
            display: block;
            position: absolute;
            padding: 6px;
            border-radius: 50%;
            background-color: #ffffff;
            animation: loading 1.4s ease-in-out 0s infinite;

            &:nth-child(1) {
              animation-delay: 0s;
            }

            &:nth-child(2) {
              animation-delay: 0.15s;
            }

            &:nth-child(3) {
              animation-delay: 0.3s;
            }

            &:nth-child(4) {
              animation-delay: 0.45s;
            }

            &:nth-child(5) {
              animation-delay: 0.6s;
            }
          }
        }

        .disabled {
          .title {
            .icon {
              vertical-align: sub;
              margin-right: 10px;
            }
            font-size: 15px;
            text-align: center;
            color: #ffffff;
          }
          .desc {
            font-size: 13px;
            line-height: 1.54;
            color: #aaaaaa;
            position: relative;
            margin-top: 23px;
            margin-bottom: 17px;
            padding-top: 19px;
            &:before {
              position: absolute;
              top: 0;
              left: 50%;
              transform: translateX(-50%);
              content: '';
              display: inline-block;
              width: 60px;
              height: 1px;
              border-top: 1px solid #555;
            }
          }
        }
      }

      .capture-after {
        overflow: auto;
        overflow-x: hidden;
        position: absolute;
        top: 35px;
        bottom: 0px;
        left: 0px;
        box-sizing: border-box;
        width: 580px;
        .capture-container {
          position: relative;
          margin: 0 auto;
          display: none;
          overflow: hidden;

          &.on {
            width: 100%;
            display: block;

            &.desktop,
            &.tablet {
              width: 580px;
            }

            &.phone {
              width: 375px;
            }
          }

          .coords_rect {
            position: absolute;
            border: dashed 1px #29e2ff;
            background-color: rgba(41, 226, 255, 0.1);

            &.tracking_tag {
              border-color: #ffe30d;
              background-color: rgba(255, 227, 13, 0.2);
            }
          }
          .mask {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background-color: #282b39;
            opacity: 0.7;
          }
        }
        .coords_rect {
          position: absolute;
          // transition: all 0.1s ease-in-out;
          border: dashed 1px #29e2ff;
          background-color: rgba(41, 226, 255, 0.1);
          box-sizing: border-box;

          &:hover {
            opacity: 1;
            border: solid 1px #29e2ff;
            background-color: rgba(41, 226, 255, 0.25);
          }

          &.active {
            border-color: transparent;
          }

          .coord_detail {
            position: absolute;
            z-index: 310;
            box-sizing: border-box;
            width: 191px;
            top: 0;
            left: -1px;
            padding: 5px 13px;
            white-space: nowrap;
            border-radius: 8px;
            pointer-events: none;
            box-shadow: 0 8px 15px 0 rgba(0, 0, 0, 0.16), 0 0 0 1px rgba(0, 0, 0, 0.16);
            background-color: #ffffff;
            font-size: 13px;
            color: #666666;
          }

          .coord_detail.size_calculation {
            opacity: 0;
            .arrow-up,
            .arrow-down {
              display: none;
            }
          }

          &.coords_rect_except {
            z-index: 300;
            border: 1px solid #ffe310;
            background-color: rgba(255, 227, 13, 0.3);
            &.except {
              pointer-events: auto;
              border-color: #ab85ff;
              background-color: rgba(171, 133, 255, 0.3);
              border: none;
              background: none;
            }
            &.disabled {
              pointer-events: none;
            }
          }

          &.tracking_tag {
            border-color: #ffe30d;
            background-color: rgba(255, 227, 13, 0.2);

            &:hover {
              border-color: #ffe30d;
              background-color: rgba(255, 227, 13, 0.25);
            }
          }

          &.edit {
            border: 0px;
            padding: 2px;
            background-color: rgba(255, 245, 0, 0.3);

            &:hover {
              border-color: #ffe30d;
              background-color: rgba(255, 245, 0, 0.3);
            }
          }
        }
      }

      .capture-failure {
        margin-top: 60px;
        text-align: center;
        font-weight: bold;
        .title {
          .icon {
            vertical-align: sub;
            margin-bottom: 10px;
          }
          font-size: 15px;
          text-align: center;
          color: #ffffff;
        }
        .desc {
          font-size: 13px;
          line-height: 1.54;
          color: #aaaaaa;
          &.first {
            position: relative;
            margin-top: 23px;
            padding-top: 19px;
            &:before {
              position: absolute;
              top: 0;
              left: 50%;
              transform: translateX(-50%);
              content: '';
              display: inline-block;
              width: 60px;
              height: 1px;
              border-top: 1px solid #555;
            }
          }
          b {
            color: #fff;
          }
        }
      }

    }
  }
  .btn-wrap {
    display: flex;
    width: 100%;
    justify-content: space-between;
    position: relative;
    left: 0;
    bottom: -5px;
    .reg-btn-wrap {
      position: relative;
      &::before {
        content: "";
        display: block;
        position: absolute;
        top: 7px;
        left: -15px;
        width: 1px;
        height: 24px;
        background-color: #a5a3a3;
      }
    }
  }
  @keyframes loading {
    0% {
      transform: translateX(-15px);
      opacity: 0;
    }
    50% {
      opacity: 1;
    }
    100% {
      transform: translateX(180px);
      opacity: 0;
    }
  }
}
</style>
